module.exports = __webpack_public_path__ + "img/body-position-goal-slide1.06eae7a8.gif";